const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1025 1024",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2465,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_5",
    transform: "matrix(1,0,0,1,2465.88,2.27374e-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1024,
    height: 1024,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 512,
    style: {
      fill: "rgb(204,107,63)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.965926,0.258819,-0.258819,0.965926,-2232.48,-753.362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2828.26,569.856C2872.56,499.373 2878.26,411.275 2843.4,335.672C2834.86,317.021 2829.57,299.266 2829.57,283.81C2829.57,201.957 2896.02,135.503 2977.88,135.503C3059.73,135.503 3126.18,201.957 3126.18,283.81C3126.18,299.266 3120.89,317.021 3112.32,335.657C3077.45,411.271 3083.15,499.382 3127.47,569.875C3154.06,612.002 3173.45,654.402 3173.45,688.387C3173.45,796.327 3085.82,883.961 2977.88,883.961C2869.94,883.961 2782.3,796.327 2782.3,688.387C2782.3,654.402 2801.69,612.002 2828.26,569.856Z",
    style: {
      fill: "white"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.fbceb74f2625bc6b1d5449b5a6ac713b.svg";
export { ForwardRef as ReactComponent };